module.exports = __webpack_public_path__ + "img/bg_function02_1_m.006041f9.png";